import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

import {
  FaWhatsapp,
  FaChevronRight,
  FaShoppingBag,
  FaStore,
  FaRobot,
  FaGamepad,
  FaNewspaper,
  FaMapMarkerAlt,
  FaShoppingCart,
  FaReceipt,
  FaUserCircle,
  FaClipboardList,
  FaTaxi,
  FaMotorcycle,
  FaBoxOpen,
  FaWallet,
} from "react-icons/fa";

import {
  doc,
  getDoc,
} from "firebase/firestore";

import { useAuth } from "../context/AuthContext";
import { db } from "../firebase";

import "../styles/More.css";

export default function More() {
  const navigate = useNavigate();

  const {
    user,
    userProfile,
  } = useAuth();

  /* =====================================================
     DELIVERY PERSON STATE
  ===================================================== */

  const [deliveryApplication, setDeliveryApplication] =
    useState(null);

  const [deliveryLoading, setDeliveryLoading] =
    useState(true);

  /* =====================================================
     CHECK DELIVERY PERSON APPLICATION
     
     Firestore:
     deliveryPersons/{user.uid}
  ===================================================== */

  useEffect(() => {
    const checkDeliveryPerson = async () => {
      if (!user) {
        setDeliveryApplication(null);
        setDeliveryLoading(false);
        return;
      }

      try {
        setDeliveryLoading(true);

        const deliveryRef = doc(
          db,
          "deliveryPersons",
          user.uid
        );

        const snap = await getDoc(deliveryRef);

        if (snap.exists()) {
          setDeliveryApplication({
            id: snap.id,
            ...snap.data(),
          });
        } else {
          setDeliveryApplication(null);
        }
      } catch (error) {
        console.error(
          "Failed to check delivery person:",
          error
        );

        setDeliveryApplication(null);
      } finally {
        setDeliveryLoading(false);
      }
    };

    checkDeliveryPerson();
  }, [user]);

  /* =====================================================
     DELIVERY STATUS
  ===================================================== */

  const deliveryStatus =
    deliveryApplication?.applicationStatus ||
    "";

  const isDeliveryPerson =
    deliveryStatus === "APPROVED";

  const deliveryApplicationPending =
    deliveryStatus === "PENDING";

  const deliveryApplicationRejected =
    deliveryStatus === "REJECTED";

  /* =====================================================
     SECTION
  ===================================================== */

  const Section = ({ title, children }) => (
    <>
      <div className="more-section-title">
        {title}
      </div>

      <div className="more-card">
        {children}
      </div>
    </>
  );

  /* =====================================================
     ITEM
  ===================================================== */

  const Item = ({
    icon,
    label,
    onClick,
  }) => (
    <div
      className="more-item"
      onClick={onClick}
    >
      <div className="more-item-left">
        {icon}
        <span>{label}</span>
      </div>

      <FaChevronRight className="arrow" />
    </div>
  );

  return (
    <div className="more-page">

      {/* =================================================
          SHOPPING
      ================================================= */}

      <Section title="🛍 Shopping">

        <Item
          icon={
            <FaShoppingBag className="more-icon" />
          }
          label="Products"
          onClick={() =>
            navigate("/allproducts")
          }
        />

        <Item
          icon={
            <FaStore className="more-icon" />
          }
          label="Shops"
          onClick={() =>
            navigate("/shops")
          }
        />

        <Item
          icon={
            <FaShoppingCart className="more-icon" />
          }
          label="Cart"
          onClick={() =>
            navigate("/cart")
          }
        />

        <Item
          icon={
            <FaReceipt className="more-icon" />
          }
          label="My Orders"
          onClick={() =>
            navigate("/orders")
          }
        />

      </Section>


      {/* =================================================
          DISCOVER
      ================================================= */}

      <Section title="📰 Discover">

        <Item
          icon={
            <FaMapMarkerAlt className="more-icon" />
          }
          label="Local Updates"
          onClick={() =>
            navigate("/localupdates")
          }
        />

        <Item
          icon={
            <FaNewspaper className="more-icon" />
          }
          label="Info Exchange"
          onClick={() =>
            navigate("/ie")
          }
        />

        <Item
          icon={
            <FaRobot className="more-icon" />
          }
          label="AI Shop"
          onClick={() =>
            navigate("/ai")
          }
        />

        <Item
          icon={
            <FaGamepad className="more-icon" />
          }
          label="Play"
          onClick={() =>
            navigate("/play")
          }
        />

      </Section>


      {/* =================================================
          TRANSPORT
      ================================================= */}

      <Section title="🚖 Transport">

        <Item
          icon={
            <FaTaxi className="more-icon" />
          }
          label="Book Auto"
          onClick={() =>
            navigate("/autos")
          }
        />

        <Item
          icon={
            <FaTaxi className="more-icon" />
          }
          label="Join as Auto Driver"
          onClick={() =>
            navigate("/join-auto")
          }
        />

        <Item
          icon={
            <FaClipboardList className="more-icon" />
          }
          label="Ride Requests"
          onClick={() =>
            navigate("/ride-requests")
          }
        />

        <Item
          icon={
            <FaReceipt className="more-icon" />
          }
          label="My Rides"
          onClick={() =>
            navigate("/my-rides")
          }
        />

      </Section>


      {/* =================================================
          DELIVERY
          ABOVE ACCOUNT
      ================================================= */}

      <Section title="🚚 Delivery">

        {deliveryLoading ? (

          <div
            style={{
              padding: "14px",
              textAlign: "center",
              color: "#6b7280",
              fontSize: 13,
            }}
          >
            Checking delivery status...
          </div>

        ) : isDeliveryPerson ? (

          /* =============================================
             APPROVED DELIVERY PERSON
          ============================================= */

          <>
            <Item
              icon={
                <FaMotorcycle className="more-icon" />
              }
              label="Delivery Dashboard"
              onClick={() =>
                navigate(
                  "/delivery-dashboard"
                )
              }
            />

            <Item
              icon={
                <FaBoxOpen className="more-icon" />
              }
              label="Delivery Orders"
              onClick={() =>
                navigate(
                  "/delivery-orders"
                )
              }
            />

            <Item
              icon={
                <FaWallet className="more-icon" />
              }
              label="Delivery Earnings"
              onClick={() =>
                navigate(
                  "/delivery-earnings"
                )
              }
            />
          </>

        ) : deliveryApplicationPending ? (

          /* =============================================
             APPLICATION PENDING
          ============================================= */

          <Item
            icon={
              <FaMotorcycle className="more-icon" />
            }
            label="Delivery Application Pending"
            onClick={() =>
              navigate("/join-delivery")
            }
          />

        ) : deliveryApplicationRejected ? (

          /* =============================================
             APPLICATION REJECTED
          ============================================= */

          <Item
            icon={
              <FaMotorcycle className="more-icon" />
            }
            label="Delivery Application Rejected"
            onClick={() =>
              navigate("/join-delivery")
            }
          />

        ) : (

          /* =============================================
             NO APPLICATION
          ============================================= */

          <Item
            icon={
              <FaMotorcycle className="more-icon" />
            }
            label="Join as Delivery Person"
            onClick={() =>
              navigate("/join-delivery")
            }
          />

        )}

      </Section>


      {/* =================================================
          ACCOUNT
      ================================================= */}

      <Section title="👤 Account">

        <Item
          icon={
            <FaUserCircle className="more-icon" />
          }
          label="Profile"
          onClick={() =>
            navigate("/user/profile")
          }
        />

        <Item
          icon={
            <FaClipboardList className="more-icon" />
          }
          label="Bills"
          onClick={() =>
            navigate("/bills")
          }
        />

        <Item
          icon={
            <FaReceipt className="more-icon" />
          }
          label="Loans"
          onClick={() =>
            navigate("/loans")
          }
        />

      </Section>


      {/* =================================================
          SUPPORT
      ================================================= */}

      <Section title="⚙ Support">

        <Item
          icon={
            <FaWhatsapp className="more-icon green" />
          }
          label="Contact Support"
          onClick={() =>
            window.open(
              "https://wa.me/918012044114",
              "_blank"
            )
          }
        />

      </Section>

    </div>
  );
}